import { useEffect, useCallback } from 'react';

/**
 * Hook para rolagem infinita
 * @param {function} callback - A função para carregar mais (loadMoreGames)
 * @param {boolean} isLoading - Se o carregamento PRINCIPAL está ativo
 * @param {boolean} isFetchingMore - Se o carregamento de "mais" está ativo
 * @param {boolean} hasNextPage - Se há mais páginas
 */
export function useInfiniteScroll(callback, isLoading, isFetchingMore, hasNextPage) {

    const handleScroll = useCallback(() => {
        // Detecta se é mobile (largura da tela menor que 768px)
        const isMobile = window.innerWidth <= 768;
        
        // Aumenta o buffer no mobile porque o footer empilhado é muito mais alto
        const buffer = isMobile ? 1500 : 700; 

        const isAtBottom = 
            window.innerHeight + document.documentElement.scrollTop >= 
            document.documentElement.offsetHeight - buffer;

        if (isAtBottom && !isFetchingMore && hasNextPage) {
            callback();
        }
    }, [isFetchingMore, hasNextPage, callback]);

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [handleScroll]);

    useEffect(() => {
        if (!isLoading) {
            handleScroll();
        }
    }, [isLoading, handleScroll]);
}